const config = {
  initiateLoginEndpoint: process.env.REACT_APP_START_LOGIN_PAGE_URL,
  clientId: process.env.REACT_APP_CLIENT_ID,
  appRegURI: process.env.REACT_APP_APP_REG_URI,
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT,
  basicAuthCredentials: process.env.REACT_APP_BASIC_AUTH_CREDENTIALS,
  alightClientId: process.env.REACT_APP_ALIGHT_CLIENT_ID,
  brokerUserId: process.env.REACT_APP_BROKERUSERID,
  subjectId: process.env.REACT_APP_SUBJECTID,
  subjectType: process.env.REACT_APP_SUBJECTTYPE,
  testCfg: process.env.REACT_APP_TESTCFG,
  requestHeaderKey: process.env.REACT_APP_REQUEST_HEADER_KEY,
  requestHeaderValue: process.env.REACT_APP_REQUEST_HEADER_VALUE,
  testCfgMapClientIdKey: process.env.REACT_APP_TESTCFGMAP_CLIENTID_KEY,
  testCfgMapKey: process.env.REACT_APP_TESTCFGMAP_KEY,
  testCfgMapValue: process.env.REACT_APP_TESTCFGMAP_VALUE,
  testCfgMapInstanceIdKey: process.env.REACT_APP_TESTCFGMAP_INSTANCEID_KEY
};

export default config;
